import { render, staticRenderFns } from "./PopupNotificationStats.vue?vue&type=template&id=0a9d03af&scoped=true"
import script from "./PopupNotificationStats.vue?vue&type=script&lang=js"
export * from "./PopupNotificationStats.vue?vue&type=script&lang=js"
import style0 from "./PopupNotificationStats.vue?vue&type=style&index=0&id=0a9d03af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9d03af",
  null
  
)

export default component.exports